var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0459 0.263856C12.356 0.441035 12.6129 0.698002 12.7901 1.00806L21.3438 15.9769C21.8918 16.936 21.5586 18.1577 20.5996 18.7057C20.2974 18.8784 19.9553 18.9692 19.6073 18.9692H2.5C1.39543 18.9692 0.5 18.0738 0.5 16.9692C0.5 16.6212 0.590831 16.2791 0.763514 15.9769L9.31715 1.00806C9.86517 0.0490294 11.0869 -0.284164 12.0459 0.263856ZM11 12.75C10.2857 12.75 9.75 13.278 9.75 13.982C9.75 14.718 10.2695 15.246 11 15.246C11.7143 15.246 12.25 14.718 12.25 13.998C12.25 13.278 11.7143 12.75 11 12.75ZM12 5H10V11H12V5Z",
    fill: "#F59D18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.9b4aaf2c412649a353dee2ed797ea199.svg";
export { ForwardRef as ReactComponent };